import { Component, OnInit } from '@angular/core';
import { CommmonService } from 'src/app/utils/common.service';
import { CategoriesService } from 'src/app/home/categories/services/categories.service';
import { Faqs } from 'src/app/home/models/faqs.interface';

@Component({
  selector: 'app-panel-plan',
  templateUrl: './panel-plan.component.html',
  styleUrls: ['./panel-plan.component.scss'],
})
export class PanelPlanComponent implements OnInit {
  openmodal = 0;
  buttonSelection: boolean[] = [
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ];
  faqs!: Faqs[];

  constructor(
    private categoriesService: CategoriesService,
    private commonService: CommmonService,
  ) {}

  async ngOnInit(): Promise<void> {
    await this.getfaqs();
  }

  async getfaqs() {
    this.commonService.removeItemLocalStorage('faqs');
    this.faqs = this.commonService.sortArray(
      (await this.categoriesService.getFaqs()) ?? [],
    );
    this.commonService.setItemLocalStorage('faqs', JSON.stringify(this.faqs));
  }

  openDiv(num: number) {
    if (this.openmodal === num) {
      this.openmodal = 0;
      this.selectButton(0);
    } else {
      this.openmodal = num;
      this.selectButton(num);
    }
  }

  selectButton(num: number) {
    for (let i = 2; i < this.buttonSelection.length; i++) {
      this.buttonSelection[i] = i === num;
    }
  }
}
